import React from 'react';
import {NoDataMsg} from '@albert-io/atomic';

import InviteDropdownBtn from '../InviteDropdownBtn/InviteDropdownBtn.react';

const NoPendingInvitationsMessage = () => {
  return (
    <NoDataMsg.Container>
      <NoDataMsg.Heading>No pending invitations</NoDataMsg.Heading>
      <NoDataMsg.Body className='u-mar-b_5'>
        All invitations were accepted. You can invite more students by clicking the button below.
      </NoDataMsg.Body>
      <InviteDropdownBtn color='secondary' />
    </NoDataMsg.Container>
  );
};

export default NoPendingInvitationsMessage;
